import { render, staticRenderFns } from "./ParallelSlot.vue?vue&type=template&id=36419624"
import script from "./ParallelSlot.vue?vue&type=script&lang=js"
export * from "./ParallelSlot.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports